/* Finish filter — client side, no reload. Quiet row, not a sidebar. */
(function(){
  document.addEventListener('click',function(e){
    var b=e.target.closest('.wxc-filter__btn'); if(!b) return;
    var want=b.dataset.finish, bar=b.closest('[data-wxc-filter]');
    bar.querySelectorAll('.wxc-filter__btn').forEach(function(x){x.classList.toggle('is-on',x===b);});
    document.querySelectorAll('[data-wxc-grid] .wxc-item').forEach(function(li){
      li.hidden = !(want==='all' || li.dataset.finish===want);
    });
  });
})();
